import {
  Component,
  HostBinding,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

import { AlertSnackBarData } from '../types';

/**
 * Alert SnackBar Component
 */
@Component({
  selector: 'mimecast-ui-alert-snack-bar',
  templateUrl: './alert-snack-bar.component.html',
  styleUrls: ['./alert-snack-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AlertSnackBarComponent {
  /**
   * Host binding for the 'data-test' attribute
   * It binds the property to the corresponding DOM attribute 'data-test'
   * This is used for testing
   */
  @HostBinding('attr.data-test') dataTest = 'alert-snack-bar';

  /**
   * Constructor for AlertSnackBarComponent
   * @param snackBarRef - The reference to MatSnackBar
   * @param data - The data required for the Alert Snackbar
   */
  constructor(
    private readonly snackBarRef: MatSnackBarRef<AlertSnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: AlertSnackBarData
  ) {}

  /**
   * This function marks the snackbar action as clicked
   */
  onAction() {
    this.snackBarRef.dismissWithAction();
  }

  /**
   * This function dismisses the snack bar
   */
  onClosed() {
    this.snackBarRef.dismiss();
  }
}
